import { ReactElement } from 'react'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { PickOrderLine } from '../draft'

/**
 * Orders cancelled out from under the picker mid-run.
 *
 * Supply Chain can cancel a fulfillment order while its pick order is open, and
 * completing the run will leave those lines out. A picker may already be holding
 * the units, so this says so plainly and names what to put back rather than
 * letting the lines quietly disappear from the Pick step.
 */
export default function CancelledLinesNotice( { lines }: { lines: PickOrderLine[] } ): ReactElement {
	return (
		<Alert severity="warning">
			<AlertTitle>
				{lines.length === 1 ? 'An order in this run was cancelled' : 'Orders in this run were cancelled'}
			</AlertTitle>
			<Typography variant="body2" sx={{ mb: 1 }}>
				Put these back if you’ve picked them.
			</Typography>
			<Box component="ul" sx={{ m: 0, pl: 2.5 }}>
				{lines.map( ( line ) => (
					<Box component="li" key={line.id}>
						<Typography variant="body2">
							{line.quantityToPick} × {line.product.name}
							{line.product.partNumber ? ` (${line.product.partNumber})` : ''}
							{line.binLocation ? ` — bin ${line.binLocation}` : ''}
							{' · '}
							FO-{line.fulfillmentOrder.orderNumber}
						</Typography>
					</Box>
				) )}
			</Box>
		</Alert>
	)
}
